import { z } from "zod"

export const GROUPINGS = [
  "status",
  "outcome",
  "customer",
  "asset",
  "department",
  "sales_rep",
] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const GROUPING_LABELS: Record<Grouping, string> = {
  status: "Status",
  outcome: "Outcome",
  customer: "Customer",
  asset: "Asset",
  department: "Department",
  sales_rep: "Sales rep",
}
